import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DateTime } from 'luxon';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent implements OnInit {
  currentDate = DateTime.now().toLocaleString(DateTime.DATE_FULL);

  constructor() {}

  ngOnInit() {}
}
